<template>
  <div class="detail-container">
    <el-button @click="$router.back()">返回列表</el-button>
    <el-card v-loading="loading" :loading-text="'加载中...'">
      <el-descriptions column="1" border>
        <el-descriptions-item label="客户 ID">{{ customer.customer_id }}</el-descriptions-item>
        <el-descriptions-item label="名称">{{ customer.name }}</el-descriptions-item>
        <el-descriptions-item label="联系方式">{{ customer.contact || '无' }}</el-descriptions-item>
        <el-descriptions-item label="地址">{{ customer.address || '无' }}</el-descriptions-item>
      </el-descriptions>
      <div style="text-align: right; margin-top: 20px;">
        <el-button type="primary" @click="openEditDialog">编辑</el-button>
        <el-button type="danger" @click="handleDelete">删除</el-button>
      </div>
    </el-card>

    <!-- 编辑弹窗 -->
    <el-dialog title="编辑客户" v-model="editDialogVisible" width="400px">
      <el-form :model="editForm" ref="editForm" :rules="rules" label-width="80px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="contact">
          <el-input v-model="editForm.contact"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input v-model="editForm.address"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEdit">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request';

export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      customer: {},
      loading: false,
      editDialogVisible: false,
      editForm: {
        name: '',
        contact: '',
        address: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入客户名称', trigger: 'blur' },
        ],
      },
    };
  },
  created() {
    this.fetchCustomerDetail();
  },
  methods: {
    async fetchCustomerDetail() {
      this.loading = true;
      try {
        const res = await request.get(`/api/customers/${this.id}`);
        this.customer = res;
        this.editForm = {
          name: this.customer.name,
          contact: this.customer.contact,
          address: this.customer.address
        };
      } catch (error) {
        console.error('获取客户详情失败:', error);
        this.$message.error(error.message || '获取客户详情失败，请重试');
      } finally {
        this.loading = false;
      }
    },
    openEditDialog() {
      this.editDialogVisible = true;
    },
    async submitEdit() {
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          try {
            await request.put(`/api/customers/${this.id}`, this.editForm);
            this.$message.success('编辑成功');
            this.editDialogVisible = false;
            this.fetchCustomerDetail();
          } catch (error) {
            console.error('编辑客户失败:', error);
            this.$message.error(error.message || '编辑客户失败，请重试');
          }
        }
      });
    },
    async handleDelete() {
      try {
        await this.$confirm('确定删除该客户吗？删除后无法恢复！', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await request.delete(`/api/customers/${this.id}`);
        this.$message.success('删除成功');
        this.$router.push('/customers');
      } catch (error) {
        if (error === 'cancel' || error.name === 'CanceledError') {
          this.$message.info('已取消删除');
        } else {
          console.error('删除客户失败:', error);
          this.$message.error(error.message || '删除客户失败，请重试');
        }
      }
    },
  },
};
</script>

<style scoped>
.detail-container {
  padding: 20px;
  animation: fadeIn 0.3s ease;
}
.el-button:first-child {
  margin-bottom: 20px;
}
.el-descriptions {
  border-radius: 16px;
  overflow: hidden;
}
.el-descriptions__title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
  background: linear-gradient(135deg, #1e293b, #3b82f6);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  display: inline-block;
}
.el-descriptions__label {
  font-weight: 600;
  background-color: #f8fafc;
  width: 120px;
}
.el-descriptions__content {
  background-color: white;
}
.detail-container .el-card__body > div:last-child {
  margin-top: 24px;
  text-align: right;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;
}
@media (max-width: 768px) {
  .detail-container {
    padding: 12px !important;
  }
  .el-descriptions {
    font-size: 12px;
  }
  .el-descriptions__label {
    width: 80px !important;
  }
  .el-descriptions__content {
    word-break: break-all;
  }
  .detail-container .el-card__body > div:last-child {
    flex-direction: column;
    align-items: stretch;
  }
  .el-button {
    width: 100%;
    margin: 0 !important;
  }
}
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>